




















































import Vue from "vue";
import { computed, onMounted, ref } from "@vue/composition-api";
import Modal from "@/components/root/modal/Modal.vue";
import DashboardItem from "@/views/overview/common/DashboardItem.vue";
import { gen_ai_modal_config } from "./modal.config";
import { show_gen_ai_events } from "../data/drilldown";
import { INFO_CATEGORIES, InfoCategoryId } from "../data/model";

/**
 * The expanded "What is your information?"-style breakdown for the Gen AI source.
 *
 * Shared by the "Information involved in AI activity" and "# Shared By Employees"
 * cards — per Ami's note they are the same view, differing only in the labels and
 * in what the counts mean. Reuses the app's own DashboardItem card.
 */
export default Vue.extend({
  components: { Modal, DashboardItem },
  props: ["modalData"],
  setup(props) {
    const config = gen_ai_modal_config(135, 75);

    // render the grid only after the modal frame has finished animating in,
    // mirroring WhatDashboardModal — otherwise the cards reflow mid-transition
    const is_modal_open = ref(false);
    onMounted(() => {
      setTimeout(() => {
        is_modal_open.value = true;
      }, 300);
    });

    const data = computed(() => props.modalData as any);
    const title = computed(() => data.value.title);
    const items = computed(() => data.value.items || []);
    const frame_date = computed(() => data.value.frame_date || "");

    /**
     * A sub-label opens its category's shared-with-AI events. The events list
     * cannot narrow to one sub-label, so it is titled by the category it
     * actually lists rather than by the label that was clicked.
     */
    const on_item_clicked = (item: { name: string; category?: InfoCategoryId }) => {
      const category = INFO_CATEGORIES.find((c) => c.id === item.category);
      show_gen_ai_events(
        category
          ? `<b>${category.name}</b>: Information Shared with AI`
          : "Information Shared with AI",
        { widget: "accessed", category: item.category, direction: "employee" }
      );
    };

    return {
      config,
      is_modal_open,
      title,
      items,
      frame_date,
      on_item_clicked,
    };
  },
});
